import React from "react";
import _ from "lodash";
import { Body, Button, Container, Footer, Left, Right, Text, Title } from "native-base";
import { connect } from "react-redux";
import { Platform } from "react-native";
import { withTranslation } from "react-i18next";
import AuthorizedScreen from "../../components/base/AuthorizedScreen";
import { Actions, ActionTypes, INITIAL_STATE, reducer } from "../../redux/screens/homework/PracticeResultRedux";
import { NavigationService } from "../../navigation";
import LoadingIndicator from "../../components/ui/LoadingIndicator";
import UIDs from "../../UIDs";
import ResultViews from "./resultViews";
import * as Helper from "../../utils/Helper";

const uid = UIDs.screens.homework.practiceresult;

let t;
class PracticeResultScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: this._handleLoadScreenViewAsyncDone },
            [ActionTypes.UPDATE_UNIT_RESULT_ASYNC]: { done: this._handleUpdateUnitResultAsyncDone, error: action => this.displayAsyncActionError(action.error, "unitResultUpdateFailure") },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);
        t = props.t;

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        let { userHomeworkUnitId, result } = this.props;
        this.props.loadScreenViewAsync(userHomeworkUnitId, result);
    }

    refreshScreen() {
        let { userHomeworkUnitId, result } = this.props;
        this.props.loadScreenViewAsync(userHomeworkUnitId, result);
    }

    renderScreen() {
        const { data, result } = this.props.localState;

        if (!this.isActionDone(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)) return <LoadingIndicator />;

        const ResultView = ResultViews[data.unitType];

        return <Container style={{marginTop:"2px"}}><ResultView {...this.props} data={data} result={result} onReportResult={this._handleReportResult} /></Container>;
    }

    _handleReportResult = unitResult => {
        //no need to report result to server when reviewing
        if (this.props.mode === 3) return;

        const { userHomeworkUnitId } = this.props.localState.data;
        unitResult.userHomeworkUnitId = userHomeworkUnitId;

        let files = [];
        if (unitResult && unitResult.files && unitResult.files.length > 0) {
            unitResult.files
                .filter(item => !_.startsWith(item, "~/"))
                .forEach(filePath => {

                    files.push(filePath);
                });
        }

        if (unitResult.answer) unitResult.answer = Helper.convertAnswerToJson(unitResult.answer);
        if (unitResult.files) unitResult.files = JSON.stringify(unitResult.files);
        //unitResult = JSON.stringify(unitResult);
        let finalResult = {
            ...unitResult,
        }

        if (this.props.localState.data.isComprehensiveUnit) {
            finalResult = {
                ...finalResult,
                answer: JSON.stringify({
                    unitType: this.props.localState.data.unitType,
                    answer: finalResult.answer,
                }),
            };
        }

        this.props.updateUnitResultAsync(userHomeworkUnitId, finalResult);
    };
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: (userHomeworkUnitId, result) => dispatch(Actions.loadScreenViewAsync(userHomeworkUnitId, result)),
        generateBySentenceAsync: (wordList, dialogIndex) => dispatch(Actions.generateBySentenceAsync(wordList, dialogIndex)),
        updateUnitResultAsync: (files, unitResult) => dispatch(Actions.updateUnitResultAsync(files, unitResult)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(PracticeResultScreen));
